export const officeConstants = {
    COMPANY_NAME: 'SARL Maystro Services',
    COMPANY_ADRESS: 'Cooperative universitaire G2, Villa 64',
    COMPANY_DISTRICT_WILAYA: 'Kouba ,Alger',
    COMPANY_FULL_ADDRESS: 'Cooperative universitaire G2, Villa 64, Kouba ,Alger',
    COMPANY_PHONE: '0982 48 24 83',
    COMPANY_MAIL: 'support@maystro-delivery.com',

};